import { RouterProvider, createRouter } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext';
import { AppModeProvider } from './context/AppModeContext';
import { VaultProvider } from './context/VaultContext';
import { PreferencesProvider } from './hooks/usePreferences';
import { ToastProvider } from './components/ui/Toast';
import { ErrorBoundary } from './components/ui/ErrorBoundary';
import { routeTree } from './routeTree.gen';
import { trackPageView } from './lib/analytics';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const router = createRouter({ routeTree });

router.subscribe('onResolved', ({ toLocation }) => {
  trackPageView(toLocation.pathname + toLocation.searchStr);
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AppModeProvider>
          <AuthProvider>
            <VaultProvider>
            <PreferencesProvider>
              <ToastProvider>
                <RouterProvider router={router} />
              </ToastProvider>
            </PreferencesProvider>
            </VaultProvider>
          </AuthProvider>
        </AppModeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
